import { Insured, OffsetLimitPagination } from 'types';
import { CapitolaClient } from './base';

export type InsuredQuery = OffsetLimitPagination;
export class InsuredClient extends CapitolaClient<Insured> {
  public get resourceName(): string {
    return 'insured';
  }
}
